import { useMemo } from 'react';
import { Platform } from 'react-native';

import {
  rewriteHtmlAttachmentRefsToPreviewSrcs,
  rewriteHtmlPreviewSrcsToPendingRefs,
} from '../../services/pendingInlineImagePreview';
import { useHydrateInlineImagePreviews } from '../richHtmlContentShared';

/**
 * Native Image/WebView cannot load `sitescope-attachment://` — put a data URI
 * in the document. Web TipTap keeps the ref in node attrs and shows a nested
 * preview `<img>`; feeding `blob:` into the document makes `getHTML()` persist
 * preview URLs, which save then strips.
 */
export function editorHtmlFromStoredValue(
  value: string,
  isWeb = Platform.OS === 'web',
): string {
  return isWeb ? value : rewriteHtmlAttachmentRefsToPreviewSrcs(value);
}

export function useTextAreaEditorHtml(
  value: string,
  requestId?: string,
): {
  editorHtml: string;
  persistHtml: (html: string) => string;
} {
  const generation = useHydrateInlineImagePreviews(value, requestId);
  const editorHtml = useMemo(
    () => editorHtmlFromStoredValue(value),
    [generation, value],
  );

  return {
    editorHtml,
    persistHtml: rewriteHtmlPreviewSrcsToPendingRefs,
  };
}
